import React from "react";
import { Stack } from "@fluentui/react";
import Header from ".././components/Header";
import Footer from ".././components/Footer";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

const App: React.FC = () => {
  const { t, ready } = useTranslation();

  if (!ready) {
    return <div></div>;
  }

  return (
    <Stack
      styles={{
        root: { margin: "0 auto", maxWidth: "650px", textAlign: "center" },
      }}
    >
      <Header />
      <Stack styles={{ root: { padding: 20 } }}>
        <h1>{t("pricing.h1.value")}</h1>
        <p>
          <ReactMarkdown>{t("pricing.main_copy.copy")}</ReactMarkdown>
        </p>
      </Stack>
      <Footer />
    </Stack>
  );
};

export default App;
